import Toolbar from '@mui/material/Toolbar'
import { NAV_LEFT_WRAP } from 'shared/components/Nav/NavLeft'
import { breakpoints } from 'shared/theme/breakpoints'
import { Colors } from 'shared/theme/colors'
import { styled } from 'styled-components'

import logo from 'assets/images/CT-logo-small.svg'
import { CLOUDTRUCKS_MARKETING_PAGE_URL } from 'helpers/constants'

export const BasicNav = () => {
  const openCTMarketingPage = () => {
    window.location.href = CLOUDTRUCKS_MARKETING_PAGE_URL
  }

  return (
    <StyledToolbar>
      <Img src={logo} alt="CloudTrucks Logo" onClick={openCTMarketingPage} />
      <div id={NAV_LEFT_WRAP} />
    </StyledToolbar>
  )
}

const StyledToolbar = styled(Toolbar)`
  background-color: ${Colors.bgGray};
  justify-content: space-between;
  min-height: 70px;
  max-width: 1440px;
  margin: auto;

  img:has(~ #${NAV_LEFT_WRAP} > div) {
    display: none;
  }

  #${NAV_LEFT_WRAP} > div {
    margin: 0;
  }
`

const Img = styled.img`
  width: 49px;
  height: 32px;
  cursor: pointer;

  @media ${breakpoints.sm} {
    height: 24px;
  }
`
